import { Disposable } from '@classic/AppUtils/Framework/Disposable/Disposable'

export class MessageBoxViewModel extends Disposable {
  public showDescription: boolean
  public showLink: boolean
  public iconClass: string
  public title: string
  public description: string
  public link: { text: string; url: string }

  constructor(params: {
    iconClass: string
    title: string
    description: string
    link: { text: string; url: string }
  }) {
    super()
    this.iconClass = params.iconClass
    this.title = params.title
    this.description = params.description
    this.link = params.link
    this.showDescription =
      this.description !== null && this.description !== undefined && this.description.length > 0
    this.showLink = this.link !== null && this.link !== undefined
  }
}
